import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/plugins/i18n';

import dayjs from '@/plugins/dayjs';
import vuetify from '@/plugins/vuetify';
import utility from '@/plugins/utility';
import variables from '@/plugins/variables';
import { languages } from '@/assets/js/variables';

Vue.config.productionTip = false;

Vue.use(dayjs);
Vue.use(utility);
Vue.use(variables);

(() => {
  languages.forEach(async lng => {
    const file = await import(/* webpackExclude: /\.map/ */ `vuetify/es5/locale/${lng}`);
    vuetify.preset.lang.locales[lng] = file.default;
  });
})();

new Vue({
  i18n,
  name: 'mainJs',
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
